import { render } from "./EditCategoryModal.vue?vue&type=template&id=c86897d8&scoped=true"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js"

import "./EditCategoryModal.vue?vue&type=style&index=0&id=c86897d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86897d8"]])

export default __exports__